import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setCohortEnrollments } from 'Workspace/Cohorts/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { cohortId } = action;

  const workspaceCohortEnrollments = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_COHORT_ENROLLMENTS_LIST,
    cohortId,
  });

  if (workspaceCohortEnrollments.type === constants.RTM_WORKSPACE_COHORT_ENROLLMENTS_LIST_OK) {
    const enrollments = workspaceCohortEnrollments.response.enrollments;
    yield put(setCohortEnrollments(cohortId, enrollments));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspaceCohortEnrollmentsListFetch} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_COHORT_ENROLLMENTS_LIST, catchErrors, sendRequest, connection);
}
